var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
export default (function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { transform: "translate(0.5 0)", fill: "#3D3D36", d: "m7.5 1l6.5 5.0292v8.9708h-3.6892v-5.2556c0-0.28472-0.25104-0.5437-0.52703-0.5437h-4.5676c-0.27599 0-0.52703 0.25898-0.52703 0.5437v5.2556h-3.6892v-8.9708l6.5-5.0292zm-0.31604-0.8942l-6.9769 5.3333c-0.12872 0.099555-0.20791 0.26276-0.20703 0.42773v9.5998c0 0.27911 0.24924 0.53333 0.52326 0.53333h4.7093c0.27401 0 0.52326-0.25422 0.52326-0.53333v-5.1554h3.4884v5.1554c0 0.27911 0.24942 0.53333 0.52326 0.53333h4.7093c0.27401 0 0.52326-0.25422 0.52326-0.53333v-9.5998c0-0.16498-0.07814-0.32818-0.20703-0.42773l-6.9769-5.3333c-0.22849-0.14791-0.4275-0.13404-0.63209 0z" })));
});
